export default __webpack_public_path__ + "static/media/Pay_stub.4d712b09.svg";